/**
 * Form model translations
 *
 * Translation keys follow the pattern: models.form.{category}.{key}
 */
export default {
    en: {
        singular: "Form",
        plural: "Forms",

        blocks: {
            schema_builder: "Schema",
            workflow_config: "Workflow",
            reporting_config: "Reporting",
        },

        fields: {
            title: "Title",
            kind: "Kind",
            description: "Description",
            status: "Status",
            current_version_id: "Current Version",
            versions_count: "Versions",
            assignments_count: "Assignments",
            submissions_count: "Submissions",
            reporting_config: {
                pass_threshold: "Pass Threshold",
            },
            workflow_config: {
                auto_complete_task: "Auto-complete Task",
            },
            created_at: "Created",
            updated_at: "Updated",
        },

        tabs: {
            details: "Details",
            schema: "Schema",
            workflow: "Workflow",
            reporting: "Reporting",
            assignments: "Assignments",
            analytics: "Analytics",
            submissions: "Submissions",
            import_export: "Import/Export",
            sidebar_exposure: "Visibility",
        },

        options: {
            kind: {
                task: "Task",
                survey: "Survey",
                legal: "Legal",
                inspection: "Inspection",
                checklist: "Checklist",
            },
            status: {
                draft: "Draft",
                active: "Active",
                archived: "Archived",
            },
        },

        badges: {
            draft: "Draft",
            active: "Active",
            archived: "Archived",
            task: "Task",
            survey: "Survey",
            legal: "Legal",
            inspection: "Inspection",
            checklist: "Checklist",
        },

        actions: {
            publish: "Publish",
            archive: "Archive",
            assign: "Assign",
            distribute: "Distribute",
        },

        filters: {
            kind: "Kind",
            status: "Status",
        },
    },

    fr: {
        singular: "Formulaire",
        plural: "Formulaires",

        blocks: {
            schema_builder: "Schema",
            workflow_config: "Flux de travail",
            reporting_config: "Rapports",
        },

        fields: {
            title: "Titre",
            kind: "Type",
            description: "Description",
            status: "Statut",
            current_version_id: "Version actuelle",
            versions_count: "Versions",
            assignments_count: "Attributions",
            submissions_count: "Soumissions",
            reporting_config: {
                pass_threshold: "Seuil de passage",
            },
            workflow_config: {
                auto_complete_task: "Terminer la tache automatiquement",
            },
            created_at: "Cree le",
            updated_at: "Modifie le",
        },

        tabs: {
            details: "Details",
            schema: "Schema",
            workflow: "Flux de travail",
            reporting: "Rapports",
            assignments: "Attributions",
            analytics: "Analyses",
            submissions: "Soumissions",
            import_export: "Importer/Exporter",
            sidebar_exposure: "Visibilité",
        },

        options: {
            kind: {
                task: "Tâche",
                survey: "Sondage",
                legal: "Légal",
                inspection: "Inspection",
                checklist: "Liste de vérification",
            },
            status: {
                draft: "Brouillon",
                active: "Actif",
                archived: "Archivé",
            },
        },

        badges: {
            draft: "Brouillon",
            active: "Actif",
            archived: "Archive",
            task: "Tache",
            survey: "Sondage",
            legal: "Legal",
            inspection: "Inspection",
            checklist: "Liste de verification",
        },

        actions: {
            publish: "Publier",
            archive: "Archiver",
            assign: "Attribuer",
            distribute: "Distribuer",
        },

        filters: {
            kind: "Type",
            status: "Statut",
        },
    },
};
